interface ExpiringStorageItem {
  value: string;
  expirationInstant: string;
}

function setWithExpiry(
  key: string,
  value: string,
  expiryMinutes: number,
): void {
  try {
    const now = Temporal.Now.instant();
    const expiration = now.add({ minutes: expiryMinutes });
    const item: ExpiringStorageItem = {
      value,
      expirationInstant: expiration.toString(),
    };
    localStorage.setItem(key, JSON.stringify(item));
  } catch (error) {
    console.warn(`Failed to set ${key} with expiry:`, error);
  }
}

function getWithExpiry(key: string): string | null {
  try {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item: ExpiringStorageItem = JSON.parse(itemStr);
    const expirationInstant = Temporal.Instant.from(item.expirationInstant);
    const now = Temporal.Now.instant();

    if (Temporal.Instant.compare(expirationInstant, now) <= 0) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch (error) {
    console.warn(`Failed to get ${key} with expiry:`, error);
    localStorage.removeItem(key);
    return null;
  }
}

export function markExchangeOffered(): void {
  setWithExpiry("exchange-offered", "true", 30);
}

export function hasSeenExchangeOffer(): boolean {
  return getWithExpiry("exchange-offered") === "true";
}

export function markRecommendationAccepted(): void {
  setWithExpiry("recommendation-accepted", "true", 30);
}

export function hasAcceptedRecommendation(): boolean {
  return getWithExpiry("recommendation-accepted") === "true";
}
